import CardForm from '../card-form'
import Game from 'app/records/game'
import React, { PropTypes } from 'react'
import Strings from 'config/strings'
import StartGameForm from '../start-game-form'

export default React.createClass({

  propTypes: {
    game         : PropTypes.instanceOf(Game).isRequired,
    onNext       : PropTypes.func.isRequired,
    onCreateCard : PropTypes.func.isRequired,
    isFunmaster  : PropTypes.bool
  },

  getMailTo() {
    let url = window.location.origin + window.location.pathname
    let subject = "You are invited to play Gifbowl"
    let body = `I've started a game of Gifbowl! Join me at ${ url }`

    return `mailto:?subject=${ subject }&body=${ body }`
  },

  render() {
    const { game, onCreateCard, onNext, isFunmaster } = this.props

    return (
      <main className="fill-green-gradient">
        <header className="banner">
          Make Some Cards
        </header>

        <nav className="row-flex row-flex-center fill-white">
          <a href={ this.getMailTo() } className="btn btn--huge block-level--fill fill-blue color-white col">
            Share Code { game.shortcode }
          </a>

          <div className="col col-center text-align-center type-btn pad-2">
            { game.card_count } Cards
          </div>

          { isFunmaster ? <StartGameForm ref="start" game={ game } onSubmit={ onNext } /> : null }
        </nav>

        <div className="container">
          <CardForm ref="createCard" onSubmit={ onCreateCard } />
        </div>
      </main>
    )
  }
})



/** WEBPACK FOOTER **
 ** ./web/static/app/components/game/phases/collecting-cards.jsx
 **/